import React, { Component } from 'react';
import { Redirect, withRouter } from 'react-router-dom';

import UpdateFireLog from '../../components/fire_logs/UpdateFireLog';
import ConditionalLink from '../../components/shared/ConditionalLink';
import PopupBox from '../../components/shared/PopupBox';

import SlidingPane from "../../components/shared/ScrollableSlidingPane";
import { request, handleRequestErrors } from '../../helpers/Requests'


class ListOfFireLogs extends Component {
  constructor(props) {
    super(props);

    this.handleEditPanel = this.handleEditPanel.bind(this);
    this.closeEditPanel = this.closeEditPanel.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleSendEmail = this.handleSendEmail.bind(this);
  }

  state = {
    fire_logs: [],
    loaded: false,
    error: null,
    errors: {},
    showSendEmailModal: false,
    modalId: null,

    editId: null,
    editPanelToggle: false,
    unauthorized: ""
  };

  handleEditPanel(event) {
    let id = event.currentTarget.parentNode.parentNode.id;

    this.setState({
      editId: id,
      editPanelToggle: true
    });
    this.props.history.push(`${this.locationURL()}/fire-log/history/${id}`)
  }

  closeEditPanel() {
    this.setState({
      editPanelToggle: false,
      editId: null
    });
    this.props.history.push(`${this.locationURL()}/fire-log/history`);
    this.componentDidMount();
  }

  handleEmailChange(event) {
    const value = event.target.value;

    this.setState({email: value})

    event.preventDefault();
  }

  handleSendEmail(event) {
    const id = event.target.parentNode.id

    const json = JSON.stringify({
      "fire_log": {
        "email": this.state.email
      }
    })

    request("POST", `/v1/a/fire_logs/${id}/send_email`, json, () => {this.setState({unauthorized: true})})
      .then(data => {
        sessionStorage.setItem("updateSuccess", "Fire Log emailed successfully!");
        this.forceUpdate()
      })
      .catch(error => {
        handleRequestErrors(this, error)

        if (!(error instanceof Error)) {
          sessionStorage.setItem("updateSuccess", error.errors);
          this.forceUpdate()
        }
      })
  }

  locationURL() {
    // This ensures that the Users stays where they are on the site.
    if (this.props.location.pathname.includes("/location")) {
      return `/location/${this.props.location_id}`
    }
    else {
      return ""
    }
  }

  readAccess() {
    const access = localStorage.getItem("access_levels");
    return access !== null && (access.includes("admin") || access.includes("manager") || access.includes("reporting"))
  }

  writeAccess() {
    const access = localStorage.getItem("access_levels");
    return access !== null && (access.includes("admin") || access.includes("manager") || access.includes("emergency"))
  }

  renderAmendable(amendableFireLog) {
    if (this.writeAccess() && amendableFireLog) {
      return (
        <div className="amend" onClick={this.handleEditPanel}>Amendable</div>
      )
    }
    else if (this.readAccess()) {
      return (
        <div className="green-button" onClick={this.handleEditPanel}>Viewable</div>
      )
    }
    else {
      return (
        <div className="no-access" title="Reporting or Admin level required to view Fire Logs">No Access</div>
      )
    }
  }

  renderSendEmailHeader() {
    if (this.readAccess()) {
      return(
        <div className="th">Email</div>
      )
    }
  }

  renderSendEmailLink(fire_log_id) {
    if (this.readAccess()) {
      return(
        <div className="td center" id={fire_log_id} onClick={this.handleSendEmail}>
          <div className="green-button">Send Email</div>
        </div>
      )
    }
  }

  render() {
    const { fire_logs, loaded, error, unauthorized } = this.state;

    if (unauthorized) {
      return <Redirect to="/login"/>
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (loaded === false) {
      return <p>Loading ...</p>;
    }

    if (loaded) {
      return (
        <div>
          <h3 className="inline-block">List of Fire Log Results</h3>
          <PopupBox/>

          <div className="table big-table">
            <div className="tr heading">
              <div className="th">Created At</div>
              <div className="th">Submitted By</div>
              <div className="th">Status</div>
              {this.renderSendEmailHeader()}
            </div>
            {fire_logs.map((fire_log) => (
                <div className="tr" id={fire_log.id} key={fire_log.id}>
                  <ConditionalLink
                    url={`${this.locationURL()}/fire-log/history/${fire_log.id}`}
                    onClick={this.handleEditPanel}
                    className="td"
                    condition={this.readAccess()}
                  >
                    {fire_log.created_at}
                  </ConditionalLink>
                  <div className="td">{fire_log.user_name}</div>
                  <div className="td center">{this.renderAmendable(fire_log.amendable)}</div>
                  {this.renderSendEmailLink(fire_log.id)}
                </div>
            ))}
          </div>

          <SlidingPane isOpen={this.state.editPanelToggle} title="View Fire Log Result" width="50%"
            onRequestClose={() => {
              this.closeEditPanel()
            }}>
            <UpdateFireLog id={this.state.editId} location_id={this.props.location_id} writeAccess={this.writeAccess()} readAccess={this.readAccess()} closeEditPanel={this.closeEditPanel} />
          </SlidingPane>
        </div>
      );
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (props.fire_log_id !== undefined) {
      return {
        editPanelToggle: true,
        editId: props.fire_log_id
      }
    }
    else if (state.editPanelToggle && props.fire_log_id === undefined) {
      return {
        editPanelToggle: false
      }
    }
    // handle back/forward buttons
    if (props.history.action === "POP" && props.history.location.pathname.endsWith("/devices")) {
      return {
        editPanelToggle: false,
        editId: null
      }
    }
    else if (props.history.action === "POP" && props.history.location.pathname.endsWith("/new")) {
      return {
        editPanelToggle: false,
        editId: null
      }
    }
    else if (props.history.action === "POP" && props.fire_log_id !== undefined) {
      return {
        editPanelToggle: true,
        editId: props.fire_log_id
      }
    }
    else {
      return null
    }
  }

  componentDidMount() {
    // deep linking
    if (this.props.fire_log_id !== undefined && this.state.editPanelToggle === false) {
      this.setState({
        editId: this.props.fire_log_id,
        editPanelToggle: true
      });
    }

    // normal API fetching stuff
    request("GET", `/v1/a/fire_logs?location_id=${this.props.location_id}`, "", () => {this.setState({unauthorized: true})})
      .then(data => this.setState({ fire_logs: data, loaded: true }))
      .catch(error => handleRequestErrors(this, error, { loaded: true }))
  }
}

export default withRouter(ListOfFireLogs);
